export function getAvailableCams(min, max) {
  const availableCamsArray = [];
  for (let index = min; index <= max; index++) {
    availableCamsArray.push({
      value: index,
      label: index
    });
  }
  return availableCamsArray;
}
